import axios from './index'
const origin = "/co/order/",
    Itineraries='/co/Itineraries/'

const listOrders = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "LoadOrderList", param).then(res => {
            resolve(res)
        })
    })
}

const addOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "AddOrderByStore", param).then(res => {
            resolve(res)
        })
    })
}
const getDetail = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "GetLineByOrderId", param).then(res => {
            resolve(res)
        })
    })
}


const downloadTouristTemplant = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "DownloadTouristTemplant", param).then(res => {
            resolve(res)
        })
    })
}

const deleteOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "deleteOrder", param).then(res => {
            resolve(res)
        })
    })
}

const cancelOrder = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "ordercancel", param).then(res => {
            resolve(res)
        })
    })
}

const listVistors = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "LoadAllTourist", param).then(res => {
            resolve(res)
        })
    })
}
const visitorDetail = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "GetLineByTourist", param).then(res => {
            resolve(res)
        })
    })
}

const updateVisitor = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "UpdateTourist", param).then(res => {
            resolve(res)
        })
    })
}
const updateOrder = param => {
    return new Promise(resolve => {
        axios.post(origin + "UpdateOrderByStore", param).then(res => {
            resolve(res)
        })
    })
}
const deleteVisitor = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "deleteVisitor", param).then(res => {
            resolve(res)
        })
    })

}

const getContractData = (param) => {
    return new Promise(resolve => {
        axios.post(origin + "GetContractData", param).then(res => {
            resolve(res)
        })
    })
}

const downLoadOneDayContact = (orderId) => {
    return new Promise(resolve => {
        axios.get(origin + "DownLoadOneDayContact?orderId=" + orderId).then(res => {
            resolve(res)
        })
    })
}

const exportTourist = (param) => {
    return new Promise(resolve => {
        axios.post(Itineraries + "ExportTourist",param).then(res => {
            resolve(res)
        })
    })
}

export default {
    listOrders,
    listVistors,
    visitorDetail,
    addOrder,
    getDetail,
    deleteOrder,
    cancelOrder,
    deleteVisitor,
    getContractData,
    updateOrder,
    updateVisitor,
    downLoadOneDayContact,
    downloadTouristTemplant,
    exportTourist
}